export default __webpack_public_path__ + "static/media/png.bccb71a2.svg";